import { Close } from "@mui/icons-material";
import {
  alpha,
  Box,
  Chip,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

export default function FiltroHeader({
  label,
  Icon,
  selectedCount = 0,
  onRemove,
  children,
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: 1,
        py: 0.5,
        bgcolor: alpha(theme.palette.background.default, 1),
        borderBottom: "1px solid",
        borderColor: alpha(theme.palette.background.default, 1),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      <Stack direction="row" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
        <Icon fontSize="small" color="primary" />
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
        {selectedCount > 0 && (
          <Chip
            label={`${selectedCount} selecionado${
              selectedCount > 1 ? "s" : ""
            }`}
            size="small"
            color="primary"
            variant="outlined"
            sx={{
              height: 20,
              fontSize: "0.7rem",
              "& .MuiChip-label": {
                px: 1,
              },
            }}
          />
        )}
      </Stack>
      <Stack direction="row" alignItems="center" gap={0.5}>
        {children}
        <IconButton
          size="small"
          onClick={onRemove}
          sx={{ color: "text.secondary" }}
        >
          <Close fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
}
